(function(angular, module) {var tabButtonsDirective;

tabButtonsDirective = function($timeout, $document) {
  "ngInject";
  return {
    restrict: 'E',
    link: function(scope, element, attrs) {
      var clickHandler, createClickHandler, destroyClickHandler, documentClick, getListSize, itemCount, listElement, open, resize;
      listElement = element.find('ul')[0];
      clickHandler = angular.element("<div class='click-handler'></div>");
      itemCount = function() {
        return listElement.children.length;
      };
      getListSize = function() {
        var elem, values;
        values = (function() {
          var i, len, ref, results;
          ref = listElement.children;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            elem = ref[i];
            results.push(elem.offsetWidth);
          }
          return results;
        })();
        return values.reduce((function(a, b) {
          return a + b;
        }), 0);
      };
      createClickHandler = function() {
        clickHandler.css('width', listElement.offsetWidth + 'px');
        return clickHandler.on('click', open);
      };
      destroyClickHandler = function() {
        angular.element($document).off('click', documentClick);
        clickHandler.off("click", open);
        return clickHandler.remove();
      };
      resize = function() {
        var listSize, mySize;
        element.removeClass('collapsed open');
        destroyClickHandler();
        mySize = element[0].offsetWidth;
        listSize = getListSize();
        if (mySize < listSize + 24) {
          element.addClass('collapsed');
          element.append(clickHandler);
          return $timeout(createClickHandler, 100);
        }
      };
      open = function() {
        return scope.$apply(function() {
          element.addClass('open');
          return angular.element($document).on('click', documentClick);
        });
      };
      documentClick = function(event) {
        if (!element[0].contains(event.target)) {
          return scope.$apply(resize);
        }
      };
      scope.$watch(itemCount, resize);
      scope.$on('resize', resize);
      scope.$on('$stateChangeSuccess', resize);
      clickHandler.on('click', open);
      return $timeout(resize);
    }
  };
};

module.directive('tabButtons', tabButtonsDirective);
})(angular, angular.module("dyb.util.widgets"));